import React, { useState, useEffect } from 'react';
import IdentityFormSC, {
  IdentityFormTextInputSC,
  IdentityFormErrorSC,
} from './identity-form.styled';
import { Formik } from 'formik';
import IdentityFormSchema from './identity-form-rules';
import { BodyText, SmallText } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';
import Select, { components } from 'react-select';
import chevronImg from '../../../assets/img/svg/chevron-down.svg';
import IdentityDropzone from './identity-dropzone';
import { ReactComponent as DeleteIcon } from '../../../assets/img/svg/x-circle.svg';
import { ReactComponent as PdfIcon } from '../../../assets/img/svg/pdf.svg';
import { FileThumbSC } from './identity-dropzone/identity-dropzone.styled';
import { LS_ACCESS_TOKEN } from '../../../constants';

export const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={chevronImg} alt="" />
    </components.DropdownIndicator>
  );
};

const IdentityForm = ({ onSubmitForm, onBoardingDocumentTypes, intl, preFilledData, loading }) => {
  const [firstFile, setFirstFile] = useState({});
  const [firstBackFile, setFirstBackFile] = useState({});
  const [secondFile, setSecondFile] = useState({});
  const [secondBackFile, setSecondBackFile] = useState({});
  const [identityData, setIdentityData] = useState([]);

  const [formInitialValues, setFormInitialValues] = useState({
    first_identity: 1,
    first_identity_number: '',
    first_identity_image_front: '',
    first_identity_image_back: '',
    second_identity: '',
    second_identity_number: '',
    second_identity_image_front: '',
    second_identity_image_back: '',
  });

  const renderPreffiledImage = (doc, onClearFunction) => {
    const clearFile = (onClearFunction) => {
      onClearFunction();
    };

    return (
      <>
        <FileThumbSC>
          {doc.name.indexOf('.pdf') > -1 ? (
            <div className="image-wrap pdf">
              <PdfIcon />
            </div>
          ) : (
            <div className="image-wrap">
              <img
                src={`${process.env.REACT_APP_WISHMAKER_API_URI}${process.env.REACT_APP_DOC_SLUG}/${
                  doc.url
                }?token=${localStorage.getItem(LS_ACCESS_TOKEN)}`}
                alt=""
              />
            </div>
          )}

          <div className="action-wrap">
            <span onClick={() => clearFile(onClearFunction)}>
              <SmallText className="red bold">
                <FormattedMessage id="global_delete" defaultMessage={dlt['global_delete']} />
              </SmallText>
              <DeleteIcon />
            </span>
          </div>
        </FileThumbSC>
        <SmallText className="smaller">{doc.name}</SmallText>
      </>
    );
  };
  useEffect(() => {
    let newIdentityData = [];

    newIdentityData = onBoardingDocumentTypes.map(({ key, value }) => ({
      value: key,
      label: intl.formatMessage({ id: `onboarding_identity_document_type_${value}` }),
    }));
    setIdentityData(newIdentityData);
  }, [onBoardingDocumentTypes, intl]);

  useEffect(() => {
    if (Object.keys(preFilledData).length > 1) {
      setFormInitialValues({
        first_identity:
          preFilledData.identity_documents.length && preFilledData.identity_documents[0].type_id
            ? preFilledData.identity_documents[0].type_id
            : 1,
        first_identity_number:
          preFilledData.identity_documents.length &&
          preFilledData.identity_documents[0].document_number
            ? preFilledData.identity_documents[0].document_number
            : '',
        first_identity_image_front:
          preFilledData.identity_documents.length &&
          preFilledData.identity_documents[0].documents[0] &&
          preFilledData.identity_documents[0].documents[0].id
            ? null
            : '',
        first_identity_image_back:
          preFilledData.identity_documents.length &&
          preFilledData.identity_documents[0].documents[1] &&
          preFilledData.identity_documents[0].documents[1].id
            ? null
            : '',
        second_identity:
          preFilledData.identity_documents.length && preFilledData.identity_documents[1].type_id
            ? preFilledData.identity_documents[1].type_id
            : '',
        second_identity_number:
          preFilledData.identity_documents.length &&
          preFilledData.identity_documents[1].document_number
            ? preFilledData.identity_documents[1].document_number
            : '',
        second_identity_image_front:
          preFilledData.identity_documents.length &&
          preFilledData.identity_documents[1].documents[0] &&
          preFilledData.identity_documents[1].documents[0].id
            ? null
            : '',
        second_identity_image_back:
          preFilledData.identity_documents.length &&
          preFilledData.identity_documents[1].documents[1] &&
          preFilledData.identity_documents[1].documents[1].id
            ? null
            : '',
      });
    }
  }, [preFilledData]);

  const allFiles = [firstFile, firstBackFile, secondFile, secondBackFile];

  return (
    <IdentityFormSC>
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validationSchema={IdentityFormSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          onSubmitForm(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => {
          const firstIdentityHasError = errors && errors.first_identity && touched.first_identity;
          const firstIdentityNumberHasError =
            errors && errors.first_identity_number && touched.first_identity_number;
          const secondIdentityHasError =
            errors && errors.second_identity && touched.second_identity;
          const secondIdentityNumberHasError =
            errors && errors.second_identity_number && touched.second_identity_number;
          const firstIdentityImageFrontHasError =
            errors && errors.first_identity_image_front && touched.first_identity_image_front;
          const secondIdentityImageFrontHasError =
            errors && errors.second_identity_image_front && touched.second_identity_image_front;
          const firstIdentityImageBackHasError =
            errors && errors.first_identity_image_back && touched.first_identity_image_back;
          const secondIdentityImageBackHasError =
            errors && errors.second_identity_image_back && touched.second_identity_image_back;

          return (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="onboarding_identity_documents_form_headline_1"
                      defaultMessage={dlt['onboarding_identity_documents_form_headline_1']}
                    />
                  </BodyText>
                  <div className="separator"></div>
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_identity_documents_form_identity_type_placeholder"
                    defaultMessage={
                      dlt['onboarding_identity_documents_form_identity_type_placeholder']
                    }
                  >
                    {(placeholder) => (
                      <Select
                        name="first_identity"
                        instanceId={1}
                        isSearchable={false}
                        components={{ DropdownIndicator }}
                        value={
                          identityData.find((op) => op.value === values.first_identity) || null
                        }
                        placeholder={placeholder}
                        classNamePrefix={
                          firstIdentityHasError ? 'react-select-error' : 'react-select'
                        }
                        onBlur={handleBlur}
                        isOptionDisabled={(op) => op.active === false}
                        options={identityData.filter((op) => op.value === 1)}
                        noOptionsMessage={() =>
                          intl.formatMessage({
                            id: 'global_no_results',
                            defaultMessage: dlt['global_no_results'],
                          })
                        }
                        onChange={(e) => {
                          handleChange({
                            target: {
                              name: 'first_identity',
                              value: e.value,
                            },
                          });
                        }}
                      />
                    )}
                  </FormattedMessage>
                  {firstIdentityHasError ? (
                    <IdentityFormErrorSC>{errors.first_identity}</IdentityFormErrorSC>
                  ) : null}
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_identity_documents_form_identity_number_placeholder"
                    defaultMessage={
                      dlt['onboarding_identity_documents_form_identity_number_placeholder']
                    }
                  >
                    {(placeholder) => (
                      <IdentityFormTextInputSC
                        type="text"
                        name="first_identity_number"
                        placeholder={placeholder}
                        filled={values.first_identity_number}
                        hasError={firstIdentityNumberHasError}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.first_identity_number || ''}
                      />
                    )}
                  </FormattedMessage>
                  {firstIdentityNumberHasError ? (
                    <IdentityFormErrorSC>{errors.first_identity_number}</IdentityFormErrorSC>
                  ) : null}
                </div>
                {values.first_identity_image_front === null ? (
                  <div className="half-block">
                    {renderPreffiledImage(preFilledData.identity_documents[0].documents[0], () =>
                      setFieldValue('first_identity_image_front', '')
                    )}
                  </div>
                ) : (
                  <div className="half-block">
                    <IdentityDropzone
                      allFiles={allFiles}
                      name="first_identity_image_front"
                      onBlur={handleBlur}
                      hasError={firstIdentityImageFrontHasError}
                      side="front"
                      setSelectedFile={(files) => {
                        setFirstFile(files[0]);
                        handleChange({
                          target: {
                            name: 'first_identity_image_front',
                            value: files[0],
                          },
                        });
                      }}
                    />

                    {firstIdentityImageFrontHasError ? (
                      <IdentityFormErrorSC>{errors.first_identity_image_front}</IdentityFormErrorSC>
                    ) : null}
                  </div>
                )}
                {values.first_identity_image_back === null ? (
                  <div className="half-block">
                    {renderPreffiledImage(preFilledData.identity_documents[0].documents[1], () =>
                      setFieldValue('first_identity_image_back', '')
                    )}
                  </div>
                ) : (
                  <div className="half-block">
                    <IdentityDropzone
                      allFiles={allFiles}
                      name="first_identity_image_back"
                      onBlur={handleBlur}
                      hasError={firstIdentityImageBackHasError}
                      side="back"
                      setSelectedFile={(files) => {
                        setFirstBackFile(files[0]);
                        handleChange({
                          target: {
                            name: 'first_identity_image_back',
                            value: files[0],
                          },
                        });
                      }}
                    />

                    {firstIdentityImageBackHasError ? (
                      <IdentityFormErrorSC>{errors.first_identity_image_back}</IdentityFormErrorSC>
                    ) : null}
                  </div>
                )}
              </div>
              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="onboarding_identity_documents_form_headline_2"
                      defaultMessage={dlt['onboarding_identity_documents_form_headline_2']}
                    />
                  </BodyText>
                  <div className="separator"></div>
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_identity_documents_form_identity_type_placeholder"
                    defaultMessage={
                      dlt['onboarding_identity_documents_form_identity_type_placeholder']
                    }
                  >
                    {(placeholder) => (
                      <Select
                        name="second_identity"
                        instanceId={2}
                        isSearchable={false}
                        components={{ DropdownIndicator }}
                        value={
                          identityData.find((op) => op.value === values.second_identity) || null
                        }
                        placeholder={placeholder}
                        classNamePrefix={
                          secondIdentityHasError ? 'react-select-error' : 'react-select'
                        }
                        onBlur={handleBlur}
                        isOptionDisabled={(op) => op.active === false}
                        options={identityData.filter((op) => op.value !== 1)}
                        noOptionsMessage={() =>
                          intl.formatMessage({
                            id: 'global_no_results',
                            defaultMessage: dlt['global_no_results'],
                          })
                        }
                        onChange={(e) => {
                          handleChange({
                            target: {
                              name: 'second_identity',
                              value: e.value,
                            },
                          });
                        }}
                      />
                    )}
                  </FormattedMessage>
                  {secondIdentityHasError ? (
                    <IdentityFormErrorSC>{errors.second_identity}</IdentityFormErrorSC>
                  ) : null}
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_identity_documents_form_identity_number_placeholder"
                    defaultMessage={
                      dlt['onboarding_identity_documents_form_identity_number_placeholder']
                    }
                  >
                    {(placeholder) => (
                      <IdentityFormTextInputSC
                        type="text"
                        name="second_identity_number"
                        placeholder={placeholder}
                        filled={values.second_identity_number}
                        hasError={secondIdentityNumberHasError}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.second_identity_number || ''}
                      />
                    )}
                  </FormattedMessage>
                  {secondIdentityNumberHasError ? (
                    <IdentityFormErrorSC>{errors.second_identity_number}</IdentityFormErrorSC>
                  ) : null}
                </div>

                {values.second_identity_image_front === null ? (
                  <div className="half-block">
                    {renderPreffiledImage(preFilledData.identity_documents[1].documents[0], () =>
                      setFieldValue('second_identity_image_front', '')
                    )}
                  </div>
                ) : (
                  <div className="half-block">
                    <IdentityDropzone
                      allFiles={allFiles}
                      name="second_identity_image_front"
                      onBlur={handleBlur}
                      hasError={secondIdentityImageFrontHasError}
                      side="front"
                      setSelectedFile={(files) => {
                        setSecondFile(files[0]);
                        handleChange({
                          target: {
                            name: 'second_identity_image_front',
                            value: files[0],
                          },
                        });
                      }}
                    />

                    {secondIdentityImageFrontHasError ? (
                      <IdentityFormErrorSC>
                        {errors.second_identity_image_front}
                      </IdentityFormErrorSC>
                    ) : null}
                  </div>
                )}
                {values.second_identity_image_back === null ? (
                  <div className="half-block">
                    {renderPreffiledImage(preFilledData.identity_documents[1].documents[1], () =>
                      setFieldValue('second_identity_image_back', '')
                    )}
                  </div>
                ) : (
                  <div className="half-block">
                    <IdentityDropzone
                      allFiles={allFiles}
                      name="second_identity_image_back"
                      onBlur={handleBlur}
                      hasError={secondIdentityImageBackHasError}
                      side="back"
                      setSelectedFile={(files) => {
                        setSecondBackFile(files[0]);
                        handleChange({
                          target: {
                            name: 'second_identity_image_back',
                            value: files[0],
                          },
                        });
                      }}
                    />

                    {secondIdentityImageBackHasError ? (
                      <IdentityFormErrorSC>{errors.second_identity_image_back}</IdentityFormErrorSC>
                    ) : null}
                  </div>
                )}
              </div>

              <div className="row">
                <div className="full-block">
                  <BodyText>
                    <FormattedHTMLMessage
                      id="onboarding_data_accuracy_hint"
                      defaultMessage={dlt['onboarding_data_accuracy_hint']}
                    />
                  </BodyText>
                  <Button
                    type="PRIMARY"
                    className="form-submit"
                    onClick={handleSubmit}
                    withIcon
                    disabled={loading}
                  >
                    <FormattedMessage
                      id="global_continue"
                      defaultMessage={dlt['global_continue']}
                    />
                  </Button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </IdentityFormSC>
  );
};

export default injectIntl(IdentityForm);
